import { goodsCents, payableGoodsCents } from "src/utils/credit-amount";

type CartOrder = Parameters<typeof goodsCents>[0];

/**
 * The upload step's "Trenutna cena" bar: the cart as it stands, plus the
 * photos still waiting to be added.
 *
 * It used to sum only the waiting photos (`files`), which the upload empties
 * the moment it lands — so after every upload, and on every resumed cart, the
 * bar read 0,00 € while the cart drawer beside it showed the real total
 * (bug hunt C).
 *
 * The cart part is the drawer's own figure, `payableGoodsCents`: what is owed,
 * net of credit, without shipping (not chosen yet on this step). The basket
 * size the free-shipping caption measures is `goodsCents`, before credit —
 * the same split every other step makes (src/utils/credit-amount.ts).
 *
 * @param pendingCents the waiting photos, priced (`calculatePendingFilesPrice`).
 * @param photoSizeSelected no size and an empty cart is still "not available",
 *        as before; a cart with something in it always has a price.
 */
export function uploadStepPrice(args: {
  order: CartOrder;
  pendingCents: number;
  photoSizeSelected: boolean;
}): { priceCents: number | null; goodsCents: number } {
  const hasServerTotal = args.order?.amount != null;
  const cartPayable = hasServerTotal ? payableGoodsCents(args.order) : 0;
  const cartGoods = hasServerTotal ? goodsCents(args.order) : 0;
  const pending = Math.max(0, args.pendingCents || 0);

  if (!args.photoSizeSelected && cartGoods === 0) {
    return { priceCents: null, goodsCents: pending };
  }
  return { priceCents: cartPayable + pending, goodsCents: cartGoods + pending };
}
